import type { PropsWithChildren } from 'react';
// import { Toaster } from 'sonner';
import MainFooter from './main-footer';
import MainHeader from './main-header.legacy';

/**
 * @deprecated Use MainLayout instead
 * Legacy layout kept for backward compatibility
 */
export default function LegacyMainLayout({ children }: PropsWithChildren) {
  return (
    <>
      <MainHeader />
      {/* <Toaster /> */}
      {children}
      <MainFooter />
    </>
  );
}
